import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nuclino = defineConnector({
  identifier: "nuclino",
  name: "Nuclino",
  tagLine: "Knowledge base and wiki",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.nuclino\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Nuclino API settings](https://app.nuclino.com/account/api-keys) and create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.nuclino.com/v0/teams",
  },
});
